module.exports = __webpack_public_path__ + "img/intoxicated.d151089a.jpg";